export default {
  plural: 'Selected products',
  download: 'Download'
};
